import { ActionTypesCommon } from "../constants/action-types"


let initState = {
    common: {
        page: ""
    },
}

export const commonReducer = (state=initState, {type, page})=>{
    switch(type) {
        case ActionTypesCommon.SET_PAGE_CONFIG: {
            return {
                ...state,
                common: {
                    page: page
                },
            }
        }

        default: {
            return state;
        }
    }
}

export default commonReducer;
